import React, { useState } from "react";

import Message from "../../Message";
import SuccessRes from "../SuccessRes";
import { withdrawTransferSchema } from "../../../../joi/transferSchema";
import { withdrawTransferSetData } from "../../../../../context/api/transfers/withdraw-transfer/withdrawTransferSetData";
import { useValidator } from "react-joi";
import { useCookies } from "react-cookie";
import { joiErrorMessage } from "../../../extra/joiErrorMessage";
// Bootstrap
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const WithdrawTransferModal = ({
  show,
  onHide,
  lang,
  dataTranslate,
  setRefreshData,
  data,
}) => {
  var schema = withdrawTransferSchema(lang).schema;

  const initialMessageRes = {
    success: Boolean,
    message: String,
    isShow: false,
  };

  const initialSuccessMessage = {
    success: false,
    type: "",
    data: {},
  };

  const { state, setData, setExplicitField, validate, reset } =
    useValidator(schema);
  const [messageResponse, setMessageResponse] = useState(initialMessageRes);
  const [successMessage, setSuccessMessage] = useState(initialSuccessMessage);
  const [cookies] = useCookies();
  const [btnLoader, setBtnLoader] = useState(false);

  const withdrawTransfer = (e) => {
    const transferId = data.id;
    e.preventDefault();
    let credintial = {
      action: state.$data.action,
    };

    if (state.$all_source_errors.length < 1) {
      setBtnLoader(() => true);
      return withdrawTransferSetData(
        lang,
        setMessageResponse,
        cookies,
        transferId,
        credintial,
        setSuccessMessage,
        setBtnLoader
      );
    }
  };

  return (
    <>
      <Message
        messageResponse={messageResponse}
        close={() => setMessageResponse(initialMessageRes)}
        lang={lang}
      />

      <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="forget-pass-otp-form"
        dir={lang === "AR" ? "rtl" : "ltr"}
      >
        {successMessage.success ? (
          <SuccessRes
            lang={lang}
            dataTranslate={dataTranslate}
            onHide={async () => {
              await onHide();
              setSuccessMessage(initialSuccessMessage);
              setRefreshData((prev) => prev + 1);
            }}
            res={successMessage}
          />
        ) : (
          <>
            <Modal.Header className="d-flex align-items-center justify-content-center ">
              <Modal.Title
                id="contained-modal-title-vcenter"
                className="fs-2 d-flex flex-row gap-2"
              >
                <span>
                  {dataTranslate.popups.create_transfer.withdraw_title}
                </span>
                <span style={{ color: "red" }}>{data.id}</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="mx-5">
              <div dir={lang === "AR" ? "rtl" : ""}>
                <Container>
                  <Row className="mb-lg-3">
                    <Col lg={12} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.create_transfer.select}
                          <span>
                            <sup style={{ color: "red" }}> *</sup>
                          </span>
                        </Form.Label>

                        <Form.Select
                          onBlur={() => setExplicitField("action", true)}
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              action: e.target.value,
                            }));
                          }}
                          aria-label="Default select example"
                        >
                          <option selected disabled>
                            {dataTranslate.popups.create_transfer.select}
                          </option>
                          <option value="WITHDRAWN">
                            {dataTranslate.popups.create_transfer.withdraw}
                          </option>
                          <option value="CANCELED">
                            {dataTranslate.popups.create_transfer.cancill}
                          </option>
                        </Form.Select>
                      </Form.Group>
                      <Form.Text style={{ color: "red" }}>
                        {joiErrorMessage(state.$errors.action)}
                      </Form.Text>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Modal.Body>
            <Modal.Footer
              className="w-100 d-flex flex-row align-items-center"
              dir="ltr"
            >
              <div className="w-100 double-btns d-flex flex-row align-items-center justify-content-center gap-2">
                <Button
                  onClick={(e) => {
                    validate();
                    withdrawTransfer(e);
                  }}
                  disabled={btnLoader ? true : false}
                >
                  {dataTranslate.popups.create_transfer.submit}
                </Button>

                <Button
                  onClick={() => {
                    reset();
                    onHide();
                  }}
                >
                  {dataTranslate.popups.create_transfer.close}
                </Button>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
};

export default WithdrawTransferModal;
